module.exports = __webpack_public_path__ + "img/enda.815772e.webp";